import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  BASE_URL,
  EDIT_VENDOR_DATA,
  UPDATE_VENDOR_DATA,
} from "../../Constants/Config";
import { CircularProgress, Grid } from "@mui/material";
import BasicTextFields from "../../reuseableComponents/TextInputField";
import SelectDropDown from "../../reuseableComponents/SelectDropDown";
import { useAuthDetails } from "../../Common/cookiesHelper";
import PasswordShow from "../../Common/passwordShow";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import SwitchToBackButton from "../../reuseableComponents/SwitchToBackButton";
import { checkDuplicateEmailValidation } from "../../Redux/features/Reports/VendorList/VendorListSlice";
import useDebounce from "../../hooks/useDebouncs";
import { formatPhoneNumber } from "../../helperFunctions/formatPhoneNumber";
import { fetchVendorsListData } from "../../Redux/features/VendorList/vListSlice";
import { sanitizeName, wordsWithInBetweenSpace } from "../../Constants/utils";
import { PERMISSIONS } from "../../Constants/permission";
import AccessDeniedTooltip from "../../reuseableComponents/AccessDeniedTooltip";
const vendorFormValues = {
  merchant_id: "",
  id: "",
  name: "",
  // email: "",
  phone: "",
  full_address: "",
  city: "",
  zip_code: "",
  state: "",
};
const EditVendors = ({ setVisible }) => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const searchParams = new URLSearchParams(location.search);
  const [backUpEmail, setBackUpEmail] = useState("");
  const AllVendorsDataState = useSelector((state) => state.vendors);
  const { validationLoading } = useSelector((state) => state.VendorList);
  const { permissions = [] } = useSelector((state) => state.permissions || {});
  const vendorId = searchParams.get("vendorId");
  const [states, setStates] = useState([]);
  const [loader, setLoader] = useState(false);
  const hasEditVendorPermission =
    !permissions.length || permissions.includes(PERMISSIONS.MENU_EDIT_VENDOR);
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [vendorData, setVendorData] = useState(vendorFormValues);

  // email state
  const [vendorEmail, setVendorEmail] = useState("");
  const debouncedValue = useDebounce(vendorEmail, 500);
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;

  const validate = async () => {
    let isValid = true;

    const itemErrors = {};
    if (!vendorData.name || vendorData.name?.trim()?.length <= 0) {
      itemErrors.name = "Please enter a vendor name";
      isValid = false;
    } else if (!wordsWithInBetweenSpace.test(vendorData.name)) {
      itemErrors.name = "Special characters are not allowed";
      isValid = false;
    } else if (vendorData.name.trim().length > 50) {
      itemErrors.name = "Vendor Name cannot exceed 50 characters";
      isValid = false;
    }
    if (
      vendorEmail !== "" &&
      !/^(?!.*\.\.)[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        vendorEmail
      )
    ) {
      itemErrors.email = "Invalid email address";
      isValid = false;
    }
    if (vendorEmail && /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(vendorEmail)) {
      if (vendorEmail?.trim() === backUpEmail?.trim()) {
        itemErrors.email = "";
        // isValid = true;
      } else {
        const isValidMail = await checkEmailValidation(vendorEmail, "submit");
        if (!isValidMail) {
          itemErrors.email = "Email id already exist";
          isValid = false;
        }
      }
    }
    if (!/^\d{10}$/.test(vendorData.phone)) {
      itemErrors.phone = "Phone number must be 10 digits";
      isValid = false;
    }

    // if (!vendorData.full_address) {
    //   itemErrors.full_address = "Please enter a vendor address";
    //   isValid = false;
    // }
    // if (!vendorData.city) {
    //   itemErrors.city = "Please enter a vendor city";
    //   isValid = false;
    // }
    if (vendorData.zip_code !== "" && !/^\d{5}$/.test(vendorData.zip_code)) {
      itemErrors.zip_code = "ZIP code must be 5 digits";
      isValid = false;
    }
    // if (!vendorData.state) {
    //   itemErrors.state = "Please select state";
    //   isValid = false;
    // }
    setErrorMessage(itemErrors);
    return isValid;
  };

  const handleOnChange = async (event) => {
    const { name, value } = event.target;
    let errorMsg = "";
    switch (name) {
      case "name":
        if (value?.trim()?.length <= 0) {
          errorMsg = "Please enter a vendor name";
        } else if (!/[a-zA-Z]/.test(value?.trim())) {
          errorMsg = "Please enter atleast one character";
        }
        break;
      // case "email":
      //   if (value == "") {
      //     errorMsg = "";
      //   } else if (value.trim() === backUpEmail.trim()) {
      //     errorMsg = "";
      //   } else if (!/\S+@\S+\.\S+/.test(value)) {
      //     errorMsg = "Invalid email address";
      //   }
      //   break;
      case "phone":
        const numbersOnly = value?.replace(/\D/g, "");
        if (!/^\d{10}$/.test(numbersOnly)) {
          errorMsg = "Phone number must be 10 digits";
        }
        break;
      // case "zip_code":
      //   if (!/^\d{5}$/.test(value)) {
      //     errorMsg = "ZIP code must be 5 digits";
      //   }
      //   break;
      // case "full_address":
      //   if (value.length <= 0) {
      //     errorMsg = "Please enter a vendor address";
      //   }
      //   break;
      // case "city":
      //   if (value.length <= 0) {
      //     errorMsg = "Please enter a vendor city";
      //   }
      //   break;
      // case "state":
      //   if (vendorData.state === "") {
      //     errorMsg = "Please select state";
      //   }
      //   break;
      default:
        break;
    }
    setErrorMessage((prevState) => ({
      ...prevState,
      [name]: errorMsg,
    }));
    if (name != "phone") {
      setVendorData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      const numbersOnly = value?.replace(/\D/g, "");
      setVendorData((prevState) => ({
        ...prevState,
        [name]: numbersOnly,
      }));
    }
  };

  const handleName = (e) => {
    const name = sanitizeName(e.target.value);
    setVendorData((prev) => ({ ...prev, name }));
  };

  async function fetchData() {
    const getvendorData = {
      merchant_id,
      vendor_id: vendorId,
      ...userTypeData,
    };
    const { token, ...Newdata } = getvendorData;

    try {
      const response = await axios.post(BASE_URL + EDIT_VENDOR_DATA, Newdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setVendorData((prevState) => {
        const newData = { ...prevState };
        for (const key in response.data.vendor_data[0]) {
          if (newData.hasOwnProperty(key)) {
            newData[key] = response.data.vendor_data[0][key];
          }
        }
        return newData;
      });
      setVendorEmail(response.data.vendor_data[0]?.email);
      setBackUpEmail(response.data.vendor_data[0]?.email);
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  }

  const handleOnChangeEmail = (e) => {
    const { name, value } = e.target;
    let errorMsg = "";
    if (value == "") {
      errorMsg = "";
    } else if (
      !/^(?!.*\.\.)[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
    ) {
      errorMsg = "Invalid email address";
    }
    setErrorMessage((prevState) => ({
      ...prevState,
      [name]: errorMsg,
    }));
    setVendorEmail(value);
  };

  const checkEmailValidation = async (value, type) => {
    const payload = {
      merchant_id,
      email: value,
      ...userTypeData,
    };

    const data = await dispatch(checkDuplicateEmailValidation(payload));
    const isValid = data?.payload;
    if (type === "submit" && value) {
      return isValid;
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        email: isValid || isValid === undefined ? "" : "Email id already exist",
      }));
    }
  };

  useEffect(() => {
    // Fetch data when the component mounts
    fetchData();
    let data = {
      merchant_id,
      // ...userTypeData,
    };
    dispatch(fetchVendorsListData(data));
  }, []);

  // Run on query change
  useEffect(() => {
    const emailRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (debouncedValue?.trim() === backUpEmail?.trim()) {
      setErrorMessage((prev) => ({
        ...prev,
        email: "",
      }));
      return;
    } else if (emailRegex.test(debouncedValue)) {
      checkEmailValidation(debouncedValue);
    }
  }, [debouncedValue, backUpEmail]);

  useEffect(() => {
    if (
      !AllVendorsDataState.loading &&
      AllVendorsDataState.vendorListData &&
      AllVendorsDataState.vendorListData.length >= 1
    ) {
      const stateArray = AllVendorsDataState.vendorListData[2].map(
        (item) => item.State
      );
      setStates(stateArray);
    }
  }, [
    AllVendorsDataState,
    AllVendorsDataState.loading,
    AllVendorsDataState.vendorListData,
  ]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validate(); // ✅ WAIT for async validation

    if (isValid) {
      let packet = {
        ...vendorData,
        name: vendorData?.name?.trim() || "",
        email: vendorEmail?.trim() || "",
        merchant_id,
        ...userTypeData,
        login_employee_id: LoginGetDashBoardRecordJson?.employee_id
          ? LoginGetDashBoardRecordJson?.employee_id
          : null,
        // token_id: userTypeData?.token_id,
        // login_type: userTypeData?.login_type,
      };
      const { token, ...newData } = packet;
      try {
        setLoader(true);
        const response = await axios.post(
          BASE_URL + UPDATE_VENDOR_DATA,
          // updatedData,
          newData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (
          response.data.status === "false" &&
          response.data.msg === "Name already exist."
        ) {
          ToastifyAlert(
            "Name already exists. Please choose a different name.",
            "error"
          );
          setErrorMessage(
            "Name already exists. Please choose a different name."
          );
          setLoader(false);
        } else {
          setErrorMessage("");

          Navigate(-1);
        }
        ToastifyAlert("Updated Successfully.", "success");
        setLoader(false);
      } catch (error) {
        if (error?.status == 401 || error?.response?.status === 401) {
          getUnAutherisedTokenMessage();
          handleCoockieExpire();
        } else if (error?.status == "Network Error") {
          getNetworkError();
        }
      }
    }
  };

  const handleFormSubmitWithPermission = (e) => {
    if (!hasEditVendorPermission) {
      e.preventDefault();
      return;
    }
    handleFormSubmit(e);
  };

  const handleSetVendorStateChange = (newState) => {
    setVendorData((preState) => ({
      ...preState,
      state: newState["title"],
    }));
  };
  const handleCloseVendor = () => {
    Navigate("/inventory/old-vendors");
    // setVisible("VendorsDetail");
  };
  const handleKeyPress = (e) => {
    if ((e.charCode < 48 || e.charCode > 57) && e.charCode !== 8) {
      e.preventDefault();
    }
  };
  return (
    <>
      <Grid container style={{ marginTop: "1.5rem" }}>
        <Grid item xs={12} className="q-add-categories-section ">
          <Grid container sx={{ marginTop: 0, marginLeft: 0 }}>
            <Grid item xs={12}>
              <SwitchToBackButton linkTo={"/inventory/old-vendors"} title={"Edit Vendor"} />
            </Grid>
          </Grid>
          <Grid container sx={{ padding: 2.5 }}>
            <Grid item xs={12}>
              <form onSubmit={handleFormSubmitWithPermission}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className=" qvrowmain my-1">
                      <label htmlFor="vendorName">Vendor Name</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"name"}
                      value={vendorData.name}
                      onChangeFun={handleName}
                      maxLength={50}
                    />
                    {errorMessage.name && (
                      <span className="error">{errorMessage.name}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className=" qvrowmain my-1">
                      <label htmlFor="email">Email Address</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"email"}
                      value={vendorEmail}
                      onChangeFun={handleOnChangeEmail}
                    />
                    {errorMessage.email && (
                      <span className="error">{errorMessage.email}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className=" qvrowmain my-1">
                      <label htmlFor="email">Phone Number</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"phone"}
                      value={formatPhoneNumber(vendorData.phone)}
                      onChangeFun={handleOnChange}
                      onKeyPressFun={handleKeyPress}
                      maxLength={14}
                    />
                    {errorMessage.phone && (
                      <span className="error">{errorMessage.phone}</span>
                    )}
                  </Grid>
                </Grid>
                <Grid container sx={{ marginTop: 2.5 }}>
                  <Grid item xs={12}>
                    <div className=" qvrowmain my-1">
                      <label htmlFor="address">Address</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"full_address"}
                      placeholder="Address Line 1"
                      onChangeFun={handleOnChange}
                      value={vendorData.full_address}
                    />
                    {errorMessage.full_address && (
                      <span className="error">{errorMessage.full_address}</span>
                    )}
                  </Grid>
                </Grid>
                <Grid container sx={{ marginTop: 2.5 }} spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className="qvrowmain my-1">
                      <label htmlFor="city">City</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"city"}
                      value={vendorData.city}
                      onChangeFun={handleOnChange}
                      // required={"required"}
                    />
                    {errorMessage.city && (
                      <span className="error">{errorMessage.city}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className="qvrowmain my-1">
                      <label htmlFor="city">Zip</label>
                    </div>
                    <BasicTextFields
                      type={"text"}
                      name={"zip_code"}
                      value={vendorData?.zip_code}
                      onChangeFun={handleOnChange}
                      maxLength={5}
                      onKeyPressFun={handleKeyPress}
                      // required={"required"}
                    />
                    {errorMessage.zip_code && (
                      <span className="error"> {errorMessage.zip_code}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <div className="qvrowmain my-1">
                      <label htmlFor="city">State</label>
                    </div>
                    <SelectDropDown
                      listItem={
                        states && states.map((item) => ({ title: item }))
                      }
                      title={"title"}
                      selectedOption={vendorData.state}
                      onClickHandler={handleSetVendorStateChange}
                      name={"state"}
                    />
                    {errorMessage.state && (
                      <span className="error">{errorMessage.state}</span>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  xs={12}
                  sx={{ marginTop: 3 }}
                >
                  <AccessDeniedTooltip hasPermission={hasEditVendorPermission}>
                    <span>
                      <button
                        type="submit"
                        className="quic-btn quic-btn-save me-3 w-44"
                        disabled={loader || validationLoading}
                      >
                        {loader ? (
                          <CircularProgress
                            color={"inherit"}
                            className=""
                            width={15}
                            size={15}
                          />
                        ) : (
                          "Update"
                        )}
                      </button>
                    </span>
                  </AccessDeniedTooltip>
                  <button
                    // onClick={() => setVisible("VendorsDetail")}
                    onClick={() => handleCloseVendor()}
                    className="quic-btn quic-btn-cancle"
                  >
                    Cancel
                  </button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EditVendors;
